import {useRef} from 'react'
import './styles.css'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { motion} from 'framer-motion'
import { Grid } from '@mui/material'
import ModelCarousel from './ModelCarousel';
import SvgIcon from '../iconSVG';




const MotionConstraints = styled(motion.div)`
    overflow-x: hidden;
  `;

const MotionBox = styled(motion.div)`
    width: 100vw;
  `

export const {servicesTravel} = ModelCarousel()

const CarouselSevices = ({current = "" }) => {

    const constraintsRef = useRef(null)

    return (
        <section className='services-travel'>
            <MotionConstraints className='slider_container' ref={constraintsRef}>
                <MotionBox className='slider_' drag='x'  dragConstraints={constraintsRef}>
                    {
                        servicesTravel.map((item,key) => {
                            const color = current === item.title ? "#5BAFEE" : '#004274';
                            return (
                                <motion.div className='div_homeTurism' key={key}>
                                    <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                        <ul >
                                            <li className='list-carrousel-verticales'>
                                                <Link to={item.route} >
                                                    <SvgIcon color={color} size={50} name={item?.img}/>
                                                    <p style={{ color: color, fontWeight: "bold" }}>{item.title}</p>
                                                </Link>
                                            </li>
                                        </ul>
                                    </Grid>
                                </motion.div>
                            )
                        })
                    }

                </MotionBox>
            </MotionConstraints>
            

        </section>
    )
}

export default CarouselSevices